<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-tab-group
  dynamicHeight
  animationDuration="0ms"
  (selectedTabChange)="onTabChanged($event.index)"
  (click)="$event.stopPropagation()"
  >
  <mat-tab label="{{ resultCount('all') }} Total"> </mat-tab>
  <mat-tab label="{{ resultCount('succeeded') }} Succeeded"> </mat-tab>
  <mat-tab label="{{ resultCount('failed') }} Failed"> </mat-tab>
  <mat-tab label="{{ resultCount('pending') }} Pending"> </mat-tab>
  <mat-tab label="{{ resultCount('queued') }} Queued"> </mat-tab>
</mat-tab-group>
<div class="flex-container">
  @for (result of filteredResults; track result) {
    <div class="flex-item">
      <div class="flex-container">
        <div class="item-container">
          <button
            mat-button
            class="result-button"
            (click)="toggleResultDisplay(result.id); $event.stopPropagation()"
            title="{{ result.status }}: Open/Close Details"
            >
            <mat-icon
              [fontIcon]="statusIcon(result.status)"
              class="icon-20px"
            ></mat-icon>
            {{ result.vmName }}
          </button>
          @if (result.vmId) {
            <button
              mat-icon-button [attr.aria-label]="'Open ' + result.vmName"
              class="open-vm-button"
              (click)="openVmConsole(result.vmId); $event.stopPropagation()"
              title="Open {{ result.vmName }}"
              >
              <mat-icon
                class="icon-20px"
                fontIcon="mdi-open-in-new"
              ></mat-icon>
            </button>
          }
          @if (showResults[result.id]) {
            <div>
              id: {{ result.id }}<br />
              @if (showVmFields) {
                <div>
                  vmId: {{ result.vmId }}<br />
                  vmName: {{ result.vmName }}<br />
                </div>
              }
              actionParameters:<br />
              @for (k of result.actionParameters | keyvalue; track k) {
                <span
                  >&nbsp;&nbsp;&nbsp;&nbsp;{{ k.key }}:
                  {{ k.key.toLowerCase() === 'password' ? '**************' : k.value
                  }}<br
                /></span>
              }
              expirationSeconds: {{ result.expirationSeconds }}<br />
              iteration {{ result.currentIteration }} of {{ result.iterations
              }}<br />
              intervalSeconds: {{ result.intervalSeconds }}<br />
              status: {{ result.status }}<br />
              expectedOutput: {{ result.expectedOutput }}<br />
              actualOutput: {{ result.actualOutput }}<br />
              dateCreated: {{ result.dateCreated | date: 'yyyy/MM/dd HH:mm:ss'
              }}<br />
              statusDate: {{ result.statusDate | date: 'yyyy/MM/dd HH:mm:ss'
              }}<br />
              <div class="flex-container old-results">
                @for (oldResult of oldResults(result); track oldResult) {
                  <div
                    class="item-container"
                    >
                    <button
                      mat-button
                      class="result-button"
                (click)="
                  toggleResultDisplay(oldResult.id); $event.stopPropagation()
                "
                      title="{{ oldResult.status }}: Open/Close Details"
                      >
                      <mat-icon
                        [fontIcon]="statusIcon(oldResult.status)"
                        class="icon-20px"
                      ></mat-icon>
                      {{ oldResult.dateCreated | date: 'yyyy/MM/dd HH:mm:ss' }}
                    </button>
                    @if (showResults[oldResult.id]) {
                      <div>
                        id: {{ oldResult.id }}<br />
                        @if (showVmFields) {
                          <div>
                            vmId: {{ oldResult.vmId }}<br />
                            vmName: {{ oldResult.vmName }}<br />
                          </div>
                        }
                        actionParameters:<br />
                        @for (k of result.actionParameters | keyvalue; track k) {
                          <span
                            >&nbsp;&nbsp;&nbsp;&nbsp;{{ k.key }}:
                            {{
                            k.key.toLowerCase() === 'password'
                            ? '**************'
                            : k.value
                            }}<br
                          /></span>
                        }
                        expirationSeconds: {{ oldResult.expirationSeconds }}<br />
                        iteration {{ oldResult.currentIteration }} of
                        {{ oldResult.iterations }}<br />
                        intervalSeconds: {{ oldResult.intervalSeconds }}<br />
                        status: {{ oldResult.status }}<br />
                        expectedOutput: {{ oldResult.expectedOutput }}<br />
                        actualOutput: {{ oldResult.actualOutput }}<br />
                        dateCreated:
                        {{ oldResult.dateCreated | date: 'yyyy/MM/dd HH:mm:ss' }}<br />
                        statusDate:
                        {{ oldResult.statusDate | date: 'yyyy/MM/dd HH:mm:ss' }}<br />
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
